import { ASSETS_URL } from "../constants";

export const getAvatarUrl = (avatar) => {
  let str = "avatar";

  const isHelmet = avatar.helmet && avatar.helmet !== "n";

  str += !isHelmet && avatar.character ? avatar.character : "1";
  str += avatar.suit ? `_${avatar.suit}` : "_b";
  str += avatar.helmet ? `_${avatar.helmet}` : "_w";
  str += avatar.swag ? `_${avatar.swag}` : "";

  return `${ASSETS_URL}/characters/${str}.png`;
};

export const getPetUrl = (avatar) => {
  let str = null;

  if (avatar && avatar.pet) {
    str = `${ASSETS_URL}/pets/${avatar.pet}.png`;
  }

  return str;
};



// WEBPACK FOOTER //
// ./src/utils/avatar.js